import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { VegWizardDataService } from 'src/app/veg-wizard/services/veg-wizard-data.service';
import { VegWizardStateMachineService } from 'src/app/veg-wizard/services/veg-wizard-state-machine.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivateLandholderConfirmationGuard implements CanActivate {
  constructor(public vwds: VegWizardDataService,
    public stateMachine: VegWizardStateMachineService,
    public router: Router) {}

  canActivate() {

    const dataState = this.vwds.getWizardDataState();

    const result = this.stateMachine.getLandholderConfirmation(dataState);

    if (!result.isEnabled) {
      console.warn('CanActivateLandholderConfirmationGuard - Required data does not exist!');
      this.router.navigate(['home']);
      return false;
    }

    return result.isEnabled;
  }

}
